const _version = "3.8.2"
function version() {
    return _version
}
export default version
